<template>
  <v-btn
    :block="block"
    :color="color"
    :data-test-id="dataTestId"
    :disabled="disabled"
    :elevation="elevation"
    :loading="loading"
    :outlined="outlined"
    :variant="noBorders ? 'text' : undefined"
    width="width"
    @click="action()"
  >
    <v-icon v-if="icon" class="mr-2" :size="iconSize">
      {{ icon }}
    </v-icon>
    <span>
      {{ text }}
    </span>
  </v-btn>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import type { TranslateResult } from 'vue-i18n';

defineProps({
  text: {
    type: String as PropType<string | TranslateResult>,
    required: true
  },
  icon: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: 'primary'
  },
  block: {
    type: Boolean,
    default: true
  },
  outlined: {
    type: Boolean,
    default: false
  },
  elevation: {
    type: Number,
    default: 0
  },
  action: {
    type: Function,
    required: true
  },
  iconSize: {
    type: Number,
    default: 16
  },
  width: {
    type: Number,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  noBorders: {
    type: Boolean,
    default: false
  },
  showLoaderAndText: {
    type: Boolean,
    default: false
  },
  dataTestId: {
    type: String,
    default: 'attach-files'
  }
});
</script>
